import { AnimatePresence } from 'framer-motion'
import { useState } from 'react'
import { ThemeProvider } from 'styled-components'
import HeroinesBackground from './components/Background/HeroinesBackground'
import StarField from './components/Background/StarField'
import HeroSection from './components/Characters/HeroSection'
import Footer from './components/Layout/Footer'
import ScrollIndicator from './components/Layout/ScrollIndicator'
import MoonriseIntro from './components/Loading/MoonriseIntro'
import PersonalSection from './components/Personal/PersonalSection'
import { characters } from './data/characters'
import { useImagePreloader } from './hooks/useImagePreloader'
import { GlobalStyle } from './styles/globalStyles'
import { theme } from './styles/theme'

// sessionStorage key for intro state
const INTRO_PLAYED_KEY = 'arcueid-intro-played'

function App() {
    // 检查本次会话是否已播放过开场动画
    const [showIntro, setShowIntro] = useState(() => {
        try {
            return !sessionStorage.getItem(INTRO_PLAYED_KEY)
        } catch {
            return true
        }
    })

    const imagesLoaded = useImagePreloader(characters)

    const handleIntroComplete = () => {
        setShowIntro(false)
        // 标记本次会话已播放
        try {
            sessionStorage.setItem(INTRO_PLAYED_KEY, 'true')
        } catch {
            // sessionStorage 不可用时忽略
        }
    }

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle />

            <AnimatePresence>
                {showIntro && (
                    <MoonriseIntro onComplete={handleIntroComplete} />
                )}
            </AnimatePresence>

            {!showIntro && imagesLoaded && (
                <>
                    <StarField />
                    <HeroinesBackground />
                    <HeroSection />
                    <ScrollIndicator />
                    <PersonalSection />
                    <Footer />
                </>
            )}
        </ThemeProvider>
    )
}

export default App